import React from "react"
export default function Interests() {
    return(
        <div className="interests">
        <h4>Interests</h4>
        <p></p>
        <ul>
        <li>Travel</li>
        <li>Sports</li>
        <li>Photography</li>
        <li>Nature</li>
        </ul>
        </div>
    )
}